import React, { useEffect } from "react";
import PropTypes from "prop-types";
import IncentiveCatalog from "../../client_customizations/components/IncentiveCatalog/IncentiveCatalog";
import IncentiveSortControls from "../../client_customizations/components/IncentiveSortControls/IncentiveSortControls";
import LoadingSpinner from "./../../components/LoadingSpinner/LoadingSpinner";
import { FormattedMessage } from "react-intl";
import IncentiveScoreOptions from "../../client_customizations/components/IncentiveScoreOptions/IncentiveScoreOptions";
import IncentiveVehicleOptions from "../../client_customizations/components/IncentiveVehicleOptions/IncentiveVehicleOptions";

const Incentives = ({ electricVehicles, incentives, location, ip, uuid }) => {
  useEffect(() => {
    document.title = process.env.REACT_APP_PAGES_INCENTIVES_TITLE;
  });

  const renderIncentives = incentives ? (
    <IncentiveCatalog incentives={incentives} category="all" />
  ) : (
    <LoadingSpinner />
  );
  const renderOptions = (
    <>
      <IncentiveScoreOptions location={location} />
      <br />
    </>
  );
  const renderVehicleOptions = electricVehicles ? (
    <IncentiveVehicleOptions electricVehicles={electricVehicles} />
  ) : null;
  return (
    <section className="container incentives" id="Incentives">
      <div className="row mb-3 title-box">
        <div className="col-sm-12 text-center">
          <h1 className="incentives-title page-title">
            <FormattedMessage
              id="incentives.title"
              defaultMessage="Electric vehicle incentives"
              description="Electric vehicle incentives"
            />
          </h1>
          <p className="lead" style={{ paddingTop: 0}}>
            <FormattedMessage
              id="evs.incentives.subTitle"
              defaultMessage="You may be eligible for a range of incentives, including EV rebates, EV tax credits, and various other benefits. Adjust the filters to personalize your results."
              description="You may be eligible for a range of incentives, including EV rebates, EV tax credits, and various other benefits. Adjust the filters to personalize your results."
              values={{
                lineBreak: <br />,
              }}
            />
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="pull-right">
            <IncentiveSortControls />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="filterCol">
          {renderOptions}
          {renderVehicleOptions}
        </div>
        <div className="contentCol" style={{ paddingLeft: 10 }}>
          {renderIncentives}
        </div>
      </div>
    </section>
  );
};

export default Incentives;

Incentives.propTypes = {
  incentives: PropTypes.array,
  electricVehicles: PropTypes.array,
  zip: PropTypes.string,
  ip: PropTypes.string,
  uuid: PropTypes.string,
};
